import type React from 'react';
import Tooltip from '../../../../../utils/tooltip';

function stopPropagation(event: React.SyntheticEvent) {
    event.stopPropagation();
}

/**
 * Hover/focus panel for the project summary counts. Clicks inside it do not reach the
 * elements around the trigger, such as a table row that toggles on click.
 */
export function SummaryPopover({
    panel,
    children,
}: {
    panel: React.ReactNode;
    children: React.ReactElement;
}): React.ReactElement {
    return (
        <Tooltip
            rounded
            interactive
            placement="bottom-start"
            maxWidth="none"
            content={
                // A fixed width, so device rows with a usage bar fit. The default cursor, because
                // inside a clickable table row the popover would inherit the row's pointer cursor.
                <div
                    className="w-64 cursor-default"
                    onClick={stopPropagation}
                    onMouseDown={stopPropagation}
                >
                    {panel}
                </div>
            }
        >
            {children}
        </Tooltip>
    );
}
